import { gql } from "@apollo/client";

const EDIT_PRODUCT_INFORMATION = gql`
  mutation editProductInformation($input: EditProductInformation) {
    editProductInformation(input: $input) {
      status
      data
      error
    }
  }
`;
export default EDIT_PRODUCT_INFORMATION;
